// extracted by mini-css-extract-plugin
export default {"portrait":"UserPortrait_portrait__5AiBQ","innerWrapper":"UserPortrait_innerWrapper__HJl52","connectionIndicator":"UserPortrait_connectionIndicator__l2tW2"};